export default __webpack_public_path__ + "static/media/people.f32f74cc.jpg";